<template>
  <Message
    class="msg"
    icon="pi pi-clock"
    @click="openBRP()"
    @close.stop
  >
    <b>Planning upgrades over time?</b> A step-by-step renovation plan can help. Try our <span>Home upgrade roadmap</span>
    <span
      v-tooltip="'The home upgrade roadmap is a tool that helps you design a customised step-by-step renovation plan for your home. It allows you to explore, organise, and schedule energy efficiency measures across multiple years — tailored to your building’s unique characteristics and your goals.'"
      class="pi pi-question-circle"
      style="margin-left: 0.25rem; font-size: 0.85rem;"
    />
    generator.
  </Message>
</template>

><script setup lang="ts">
import Message from "primevue/message";
import {useRouter} from "vue-router";

const router = useRouter()
function openBRP() {
  router.push('/brp')
}
</script>
<style lang="scss" scoped>
span:not(.pi) {
  text-decoration: underline;
}
.msg {
  cursor: pointer;
}
:deep(.p-message-icon) {
  font-size: 1rem;
}
</style>
